import {  createSlice } from "@reduxjs/toolkit";
// import { getChatConversation, pushMessage } from "./actions/voice.community";
import { USER_PREVILEDGE } from "./interface";
import { types as Types } from "mediasoup-client";
import { enableMapSet } from 'immer';
enableMapSet()

interface UserInRoom{
    id: string
    isHandRaised: boolean
    firstname: string
    lastname: string
    isSpeaker: boolean
    picture: string
}

// class UserInfo implements UserInRoom{


//     id = "";
//     firstname;
//     lastname;
//     isHandRaised;
//     setRaiseHand(isRaisedHand:boolean){
//         this.isHandRaised = isRaisedHand
//     }
//     constructor({
//         firstname,
//         id,
//         isHandRaised,
//         lastname
//     }:{
//         id: string
//     isHandRaised: boolean
//     firstname: string
//     lastname: string
//     }){
//         this.firstname = firstname
//         this.lastname = lastname
//         this.isHandRaised =isHandRaised
//     }
// }

const initialStateX =  {
    joinedRoom: false,
    reactions:["😊","😂","🤣","❤","😍","😒","👌","👍","😢","✌","🎉","🤔","😃"],
    joinedRoomId: '',
    joinedRoomTitle: '',
    joinedRoomToken: '',
    currentRoom: '',
    producers: new Map<string,Types.Producer>(),
    consumers: new Map<string,Types.Consumer>(),
    usersInRoom: {} as Record<string,UserInRoom>,
    isMicMuted: true,
    isMicMutedByAdmin: false,
    roomStatus: '',
    roomStatusMessage: '',
    roomLoading: false,
    isRoomAdmin: false,
    userPriviledge: 'USER' as USER_PREVILEDGE,
    floatVoiceSettings: false,
    canSpeak: false,
    blockedFromRoom: false,
    isSpeaking: false,
    userHandRaised: false,
    kickedOutOfRoom: false,
    notification: [] as {type:string,message:string}[]
}

export const voiceChatSlice = createSlice({
    name: 'voice',
    initialState:initialStateX,
    reducers: {
        
        resetRoomSettings: state => initialStateX,

        setjoinRoom: (state,action) => {
            state.joinedRoom = action.payload
        },

        setNewNotification: (state,action)=> {
            state.notification.push(action.payload)
        },
        
        setRoomTokenAndId: (state,action) => {
            state.joinedRoomId = action.payload.id;
            state.joinedRoomToken = action.payload.token;
            state.joinedRoomTitle = action.payload.title;
            state.canSpeak = action.payload.canSpeak;
            state.userPriviledge = action.payload.isModrator ? "MODRATOR" : "USER";
        },

        addUsersToRoom: (state,action) => {
            action.payload.forEach((user:UserInRoom) => {
                state.usersInRoom[`${user.id}`] = user
            });
        },
        
        removeUserFromRoom: (state,action) => {
               delete state.usersInRoom[`${action.payload.id}`]
        },

        addConsumer: (state,action) =>  {
            state.consumers.set(action.payload.id,action.payload.value)
        },
        
        removeConsumer: (state,action) =>  {
            state.consumers.delete(action.payload.id)
        },
        
        joiningRoom: (state,action) =>  {
            state.roomLoading = true;
            state.roomStatusMessage= "Joining Room";
            state.joinedRoom = true
        },
        
        roomSignInError: (state,action) =>  {
            state.roomLoading = true;
            state.roomStatusMessage= "Couldn't join room";
            state.joinedRoom = true
        },
        
        addProducers: (state,action) =>  {
            state.producers.set(action.payload.id,action.payload.value)
        },

        removeProducers: (state,action) =>  {
            state.producers.delete(action.payload.id)
        },
        
        closeProducers: (state,action) =>  {
            state.producers.get(action.payload.id)?.close()
        },
        pauseProducer: (state,action) =>  {
            state.producers.get(action.payload.id)?.pause()
        },
        resumeProducer: (state,action) =>  {
            state.producers.get(action.payload.id)?.resume()
        },

        updateisSpeaking: (state,action) => {
           state.isSpeaking = action.payload
        },
        
        updateMicSetting: (state,action) => {
           state.isMicMuted = action.payload
        },

        updateUserPriviledge: (state,action) => {
            state.userPriviledge = action.payload
        },
        
        updateIsRoomLoading: (state,action) => {
            state.roomLoading = action.payload
        },
        
        updateRoomStatusMessage: (state,action) => {
            state.roomStatusMessage = action.payload
        },
        
        showFloatedVoiceSettings: (state,action) => {
            state.floatVoiceSettings = action.payload
        },
        setUserRaisedHand: (state,action) => {
            if(state.usersInRoom[action.payload.id]){
                    
                state.usersInRoom[action.payload.id] = {...state.usersInRoom[action.payload.id],isHandRaised:true}
            }
        },

        setUserDropHand: (state,action) => {
            if(state.usersInRoom[action.payload.id]){
            state.usersInRoom[action.payload.id] = {...state.usersInRoom[action.payload.id],isHandRaised:false}  
        }
        },
        
        toggleMyHand: (state)=> {
            state.userHandRaised = !state.userHandRaised
        },

        youHaveBeenKickedOut: (state)=> {
            state.kickedOutOfRoom = true
        },
        
        youHaveBeenBlocked: (state)=> {
            state.blockedFromRoom = true
        },

        temporarySpeakerUpdate: (state,action) => {
            console.log("inside update",action.payload)
            state.canSpeak = action.payload
        },

        updateUserToSpeaker:(state,action)=> {
            state.usersInRoom[action.payload.id] = {...state.usersInRoom[action.payload.id],isSpeaker:true}
        },

        removeUserAsSpeaker: (state,action) => {
            state.usersInRoom[action.payload.id] = {...state.usersInRoom[action.payload.id],isSpeaker:false}
        },

        mutedByAdminToggle: (state,action) => {
            state.isMicMutedByAdmin = action.payload
        }


    },
    extraReducers: builder =>{
        
      }
  });

  